import { FilterItem, SortItem } from 'namirasoft-core';
import { InfraUtils } from '../InfraUtils';
import useOnlineList from '../hooks/useOnlineList';

export interface InfraNodeStatusLabelProps
{
    node: { id: string, last_seen_at: Date | null }
    getOnlineList: (filters: FilterItem[] | null, page: (number | null), size: (number | null), sorts: SortItem[], all_workspaces: boolean | null) => Promise<(string | null)[]>
}

export function InfraNodeStatusLabel(props: InfraNodeStatusLabelProps)
{
    const { online_list, loading } = useOnlineList(() => props.getOnlineList([], null, null, [], null), []);

    let status = online_list ? InfraUtils.getNodeStatus(props.node, online_list) : null;

    return (
        <div className="d-flex align-items-center gap-1">
            {
                !loading && status &&
                <div className="d-flex align-items-center gap-2">
                    <div style={{ width: 20, height: 20, borderRadius: 4, background: status.color }} />
                    <span className="text-dark" style={{ lineHeight: "20px" }}>{status.title}</span>
                </div>
            }
            {
                loading &&
                <div className="spinner-border spinner-border-sm text-primary" style={{ height: 20, width: 20 }} role="status" />
            }
        </div>
    )
}

export default InfraNodeStatusLabel;